"use strict";
// FDA API utility functions for medication lookups
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchMedicationDetailsFromAPI = fetchMedicationDetailsFromAPI;
function fetchMedicationDetailsFromAPI(ndc) {
    return __awaiter(this, void 0, Promise, function () {
        var hasOriginalHyphens, originalNdc, cleanedNdc, x, y, z, productNdc, fullNdc, parts, response, data, xWithoutZero, productNdcWithoutZero, matchedMedication, _i, _a, result, _b, _c, packageItem, zWithoutZero, fullNdcWithoutZero, _d, _e, result, _f, _g, packageItem, altX, altY, altZ, altProductNdc, altFullNdc, _h, _j, result, _k, _l, packageItem, altZWithoutZero, altFullNdcWithoutZero, _m, _o, result, _p, _q, packageItem, error_1;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0:
                    _r.trys.push([0, 6, , 7]);
                    hasOriginalHyphens = ndc.includes('-');
                    originalNdc = ndc.trim();
                    cleanedNdc = ndc.replace(/\D/g, '');
                    if (cleanedNdc.length < 9 || cleanedNdc.length > 11) {
                        console.error('Invalid NDC format:', ndc);
                        return [2 /*return*/, null];
                    }
                    x = void 0, y = void 0, z = void 0, productNdc = void 0, fullNdc = void 0;
                    if (hasOriginalHyphens) {
                        parts = originalNdc.split('-');
                        if (parts.length === 3) {
                            x = parts[0];
                            y = parts[1];
                            z = parts[2];
                            productNdc = "".concat(x, "-").concat(y); // X-Y format for API request
                            fullNdc = originalNdc; // Use original format for matching
                        }
                        else if (parts.length === 2) {
                            // Handle 2-part NDCs like 00409-3308
                            x = parts[0];
                            y = parts[1];
                            z = ''; // No Z part
                            productNdc = "".concat(x, "-").concat(y); // X-Y format for API request
                            fullNdc = "".concat(x, "-").concat(y); // Full format for matching
                        }
                        else {
                            // Fallback to standard formatting if original format is invalid
                            if (cleanedNdc.length === 11) {
                                x = cleanedNdc.slice(0, 5);
                                y = cleanedNdc.slice(5, 9);
                                z = cleanedNdc.slice(9, 11);
                            }
                            else if (cleanedNdc.length === 10) {
                                x = cleanedNdc.slice(0, 5);
                                y = cleanedNdc.slice(5, 8);
                                z = cleanedNdc.slice(8, 10);
                            }
                            else if (cleanedNdc.length === 9) {
                                // Handle 9-digit NDCs (e.g., 004093308 -> 00409-3308)
                                x = cleanedNdc.slice(0, 5);
                                y = cleanedNdc.slice(5, 9);
                                z = ''; // No Z part for 9-digit NDCs
                            }
                            productNdc = "".concat(x, "-").concat(y);
                            fullNdc = z ? "".concat(x, "-").concat(y, "-").concat(z) : "".concat(x, "-").concat(y);
                        }
                    }
                    else {
                        // Standard formatting for NDCs without hyphens
                        if (cleanedNdc.length === 11) {
                            // 11-digit format: 5-4-2
                            x = cleanedNdc.slice(0, 5);
                            y = cleanedNdc.slice(5, 9);
                            z = cleanedNdc.slice(9, 11);
                        }
                        else if (cleanedNdc.length === 10) {
                            // 10-digit format: try both 4-4-2 and 5-3-2
                            // Start with 5-3-2 format
                            x = cleanedNdc.slice(0, 5);
                            y = cleanedNdc.slice(5, 8);
                            z = cleanedNdc.slice(8, 10);
                        }
                        else if (cleanedNdc.length === 9) {
                            // 9-digit format: 5-4 (no Z part)
                            x = cleanedNdc.slice(0, 5);
                            y = cleanedNdc.slice(5, 9);
                            z = '';
                        }
                        productNdc = "".concat(x, "-").concat(y); // X-Y format for API request
                        fullNdc = z ? "".concat(x, "-").concat(y, "-").concat(z) : "".concat(x, "-").concat(y); // Full X-Y-Z format for matching
                    }
                    console.log("Searching for NDC: ".concat(productNdc, " (full: ").concat(fullNdc, ")"));
                    return [4 /*yield*/, fetch("https://api.fda.gov/drug/ndc.json?search=product_ndc:".concat(productNdc, "&limit=10"))];
                case 1:
                    response = _r.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _r.sent();
                    if (!((!data.results || data.results.length === 0) && x.startsWith('0') && x.length > 1)) return [3 /*break*/, 5];
                    xWithoutZero = x.substring(1);
                    productNdcWithoutZero = "".concat(xWithoutZero, "-").concat(y);
                    console.log("Trying NDC without leading zero in X part: ".concat(productNdcWithoutZero));
                    return [4 /*yield*/, fetch("https://api.fda.gov/drug/ndc.json?search=product_ndc:".concat(productNdcWithoutZero, "&limit=10"))];
                case 3:
                    response = _r.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    data = _r.sent();
                    if (data.results && data.results.length > 0) {
                        // Update the product NDC to the one that worked for API matching
                        productNdc = productNdcWithoutZero;
                        // Update the full NDC to match the new X part for API matching
                        fullNdc = "".concat(xWithoutZero, "-").concat(y, "-").concat(z);
                        console.log("Found results with modified NDC: ".concat(productNdc, " (full: ").concat(fullNdc, ")"));
                        // Note: The original NDC format is preserved in the calling component
                    }
                    _r.label = 5;
                case 5:
                    if (!data.results || data.results.length === 0) {
                        console.log('No medication details found for NDC:', productNdc);
                        return [2 /*return*/, null];
                    }
                    matchedMedication = null;
                    // First, search in the packaging array of each result
                    for (_i = 0, _a = data.results; _i < _a.length; _i++) {
                        result = _a[_i];
                        if (result.packaging && Array.isArray(result.packaging)) {
                            for (_b = 0, _c = result.packaging; _b < _c.length; _b++) {
                                packageItem = _c[_b];
                                if (packageItem.package_ndc === fullNdc) {
                                    matchedMedication = result;
                                    break;
                                }
                            }
                            if (matchedMedication)
                                break;
                        }
                    }
                    // If not found, try searching without leading zero in Z part
                    if (!matchedMedication && z.startsWith('0') && z.length > 1) {
                        zWithoutZero = z.replace(/^0+/, '');
                        fullNdcWithoutZero = "".concat(x, "-").concat(y, "-").concat(zWithoutZero);
                        console.log("Trying NDC without leading zero: ".concat(fullNdcWithoutZero));
                        for (_d = 0, _e = data.results; _d < _e.length; _d++) {
                            result = _e[_d];
                            if (result.packaging && Array.isArray(result.packaging)) {
                                for (_f = 0, _g = result.packaging; _f < _g.length; _f++) {
                                    packageItem = _g[_f];
                                    if (packageItem.package_ndc === fullNdcWithoutZero) {
                                        matchedMedication = result;
                                        break;
                                    }
                                }
                                if (matchedMedication)
                                    break;
                            }
                        }
                    }
                    // If still not found and it's a 10-digit NDC, try alternative formats
                    if (!matchedMedication && cleanedNdc.length === 10) {
                        altX = cleanedNdc.slice(0, 4);
                        altY = cleanedNdc.slice(4, 8);
                        altZ = cleanedNdc.slice(8, 10);
                        altProductNdc = "".concat(altX, "-").concat(altY);
                        altFullNdc = "".concat(altX, "-").concat(altY, "-").concat(altZ);
                        console.log("Trying alternative format: ".concat(altProductNdc, " (full: ").concat(altFullNdc, ")"));
                        // Search in existing results for this alternative format
                        for (_h = 0, _j = data.results; _h < _j.length; _h++) {
                            result = _j[_h];
                            if (result.packaging && Array.isArray(result.packaging)) {
                                for (_k = 0, _l = result.packaging; _k < _l.length; _k++) {
                                    packageItem = _l[_k];
                                    if (packageItem.package_ndc === altFullNdc) {
                                        matchedMedication = result;
                                        break;
                                    }
                                }
                                if (matchedMedication)
                                    break;
                            }
                        }
                        // If still not found, try without leading zero for alternative format
                        if (!matchedMedication && altZ.startsWith('0') && altZ.length > 1) {
                            altZWithoutZero = altZ.replace(/^0+/, '');
                            altFullNdcWithoutZero = "".concat(altX, "-").concat(altY, "-").concat(altZWithoutZero);
                            console.log("Trying alternative format without leading zero: ".concat(altFullNdcWithoutZero));
                            for (_m = 0, _o = data.results; _m < _o.length; _m++) {
                                result = _o[_m];
                                if (result.packaging && Array.isArray(result.packaging)) {
                                    for (_p = 0, _q = result.packaging; _p < _q.length; _p++) {
                                        packageItem = _q[_p];
                                        if (packageItem.package_ndc === altFullNdcWithoutZero) {
                                            matchedMedication = result;
                                            break;
                                        }
                                    }
                                    if (matchedMedication)
                                        break;
                                }
                            }
                        }
                    }
                    if (!matchedMedication) {
                        console.log("No exact match found for NDC ".concat(fullNdc, ". Found ").concat(data.results.length, " potential matches for ").concat(productNdc, "."));
                        return [2 /*return*/, null];
                    }
                    console.log('Matched medication:', matchedMedication);
                    return [2 /*return*/, matchedMedication];
                case 6:
                    error_1 = _r.sent();
                    console.error('Error fetching medication details from FDA:', error_1);
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    });
}
